import { render, staticRenderFns } from "./UserPop.vue?vue&type=template&id=852d165a&scoped=true&"
import script from "./UserPop.vue?vue&type=script&lang=js&"
export * from "./UserPop.vue?vue&type=script&lang=js&"
import style0 from "./UserPop.vue?vue&type=style&index=0&id=852d165a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852d165a",
  null
  
)

export default component.exports